export const SalaryBrackets = {
  RMB: [150, 175, 200, 225, 250, 275, 300, 325],
  CAD: [30, 35, 40, 45, 50, 55, 60, 65],
  USD: [30, 35, 40, 45, 50, 55, 60, 65],
  GBP: [20, 25, 30, 35, 40, 45, 50, 55],
  AUD: [30, 35, 40, 45, 50, 55, 60, 65],
};

export const SalaryBracketNames = ['一档', '二档', '三档', '四档', '五档', '六档', '七档', '八档'];
export const MinutesToNextBracket = [3000, 3000, 3000, 4800, 6000, 7500, 12000, 0];

//拿到最新的薪酬方案
export function getLatestSalaryAllocation(array) {
  if (!array || array.length === 0) {
    return null;
  }
  return array.reduce((latest, current) => {
    const latestValidFrom = new Date(latest.validFrom);
    const currentValidFrom = new Date(current.validFrom);
    return latestValidFrom > currentValidFrom ? latest : current;
  }, array[0]);
}

export function getBracket(currency, number) {
  const brackets = SalaryBrackets[currency];
  if (!brackets) {
    return null;
  }
  const numberIndex = brackets.indexOf(Number(number));
  if (numberIndex === -1) {
    return null;
  }
  return SalaryBracketNames[numberIndex];
}

export function getMinutesToNextBracket(currentBracket) {
  const idx = SalaryBracketNames.indexOf(currentBracket);
  if (idx === -1) {
    return null;
  }
  return MinutesToNextBracket[idx];
}

export function getNextBracket(currentBracket) {
  const idx = SalaryBracketNames.indexOf(currentBracket);
  if (idx === -1 || idx === SalaryBracketNames.length - 1) {
    return null;
  }
  return SalaryBracketNames[idx + 1];
}

export function getBracketHourlyRate(bracket, currency) {
  const brackets = SalaryBrackets[currency];
  const idx = SalaryBracketNames.indexOf(bracket);
  if (idx === -1) {
    return null;
  }
  return brackets[idx];
}
